import { http } from '@/utils/HttpClient';
import endpoints from '@/endpoints';
import { ApiResponse } from '@/types/api';
import { Plan } from '@/features/subscription/types/plan';
import { PaddleSubscription } from '@/features/subscription/types/paddle';
import { User } from '@/types/models/user';
import { PlanMemberEnum } from '../enum/planMember';

export type EmailAuthStatus =
  | { status: 'not-registered' }
  | { status: 'registered'; providers: string[] };

export const planService = {
  async get(planUid: string): Promise<ApiResponse<Plan>> {
    return await http.fetch({
      method: endpoints.plan.get.method,
      endpoint: endpoints.plan.get.url(planUid),
    });
  },

  async getDetails(planUid: string): Promise<ApiResponse<PaddleSubscription>> {
    return await http.fetch({
      method: endpoints.plan.getDetails.method,
      endpoint: endpoints.plan.getDetails.url(planUid),
    });
  },
  async getMembers(planUid: string): Promise<
    ApiResponse<
      {
        user: User;
        role: PlanMemberEnum;
      }[]
    >
  > {
    return await http.fetch({
      method: endpoints.plan.getMembers.method,
      endpoint: endpoints.plan.getMembers.url(planUid),
    });
  },
  // async addMembers(
  //   planUid: string,
  //   emails: string[]
  // ): Promise<ApiResponse<any>> {
  //   return await http.fetch({
  //     method: endpoints.plan.addMembers.method,
  //     endpoint: endpoints.plan.addMembers.url(planUid),
  //     config: {
  //       body: { emails },
  //     },
  //   });
  // },
  async inviteMembers(
    ownerEmail: string,
    planUid: string,
    emails: string[]
  ): Promise<ApiResponse<any>> {
    return await http.fetch({
      method: endpoints.plan.inviteMembers.method,
      endpoint: endpoints.plan.inviteMembers.url(planUid),
      config: {
        body: { emails, ownerEmail },
      },
    });
  },
  async verifyInvite(inviteToken: string): Promise<
    ApiResponse<{
      valid: boolean;
      message: string;
      email?: string;
      inviter?: string;
      emailStatus?: EmailAuthStatus;
    }>
  > {
    return await http.fetch({
      method: endpoints.plan.verifyInvite.method,
      endpoint: endpoints.plan.verifyInvite.url(inviteToken),
    });
  },

  async acceptInvite(
    inviteToken: string
  ): Promise<ApiResponse<{ [key: string]: any }>> {
    return await http.fetch({
      method: endpoints.plan.acceptInvite.method,
      endpoint: endpoints.plan.acceptInvite.url(),
      config: {
        body: { token: inviteToken },
      },
    });
  },
  async removeMembers(
    planUid: string,
    emails: string[]
  ): Promise<ApiResponse<any>> {
    return await http.fetch({
      method: endpoints.plan.removeMembers.method,
      endpoint: endpoints.plan.removeMembers.url(planUid),
      config: {
        body: { emails },
      },
    });
  },
  async manageMembers(
    planUid: string,
    seats: number
  ): Promise<ApiResponse<any>> {
    return await http.fetch({
      method: endpoints.plan.manageMembers.method,
      endpoint: endpoints.plan.manageMembers.url(planUid),
      config: {
        body: { seats },
      },
    });
  },
  async suggestEmails(
    planUid: string,
    emails: string[]
  ): Promise<ApiResponse<any>> {
    return await http.fetch({
      method: endpoints.plan.suggestMembers.method,
      endpoint: endpoints.plan.suggestMembers.url(planUid),
      config: {
        body: { emails },
      },
    });
  },
  async suggestedMembers(planUid: string): Promise<ApiResponse<any>> {
    return await http.fetch({
      method: endpoints.plan.suggestedMembers.method,
      endpoint: endpoints.plan.suggestMembers.url(planUid),
    });
  },

  async removeSuggestedEmails(
    planUid: string,
    emails: string[]
  ): Promise<ApiResponse<any>> {
    return await http.fetch({
      method: endpoints.plan.removeSuggestedMembers.method,
      endpoint: endpoints.plan.removeSuggestedMembers.url(planUid),
      config: {
        body: { emails },
      },
    });
  },

  async removeInvitedEmails(
    planUid: string,
    emails: string[]
  ): Promise<ApiResponse<any>> {
    return await http.fetch({
      method: endpoints.plan.removeInvitedEmails.method,
      endpoint: endpoints.plan.removeInvitedEmails.url(planUid),
      config: {
        body: { emails },
      },
    });
  },

  async pendingInvites(planUid: string): Promise<ApiResponse<any>> {
    return await http.fetch({
      method: endpoints.plan.pendingInvites.method,
      endpoint: endpoints.plan.pendingInvites.url(planUid),
    });
  },

  async cancel(planUid: string): Promise<ApiResponse<any>> {
    return await http.fetch({
      method: endpoints.plan.cancel.method,
      endpoint: endpoints.plan.cancel.url(planUid),
    });
  },
};
